module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"dashboard":"DashboardEnglish"}')
  delete Component.options._Ctor
}
